import { PlusOutlined } from '@ant-design/icons'
import { FloatButton } from 'antd'
import clsx from 'clsx'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { RoleModal } from './components/role-modal'
import { getRoleTableColumns } from './helpers/get-role-table-columns'
import styles from './styles/roles.page.module.scss'
import { Role } from './types/roles-page-types'
import { PureTable } from '../../../common/ui/pure-table/pure-table'
import { useGetPermissions } from '../../../entities/permissions/hooks/permissions.hooks'
import { useGetRoles, useRoleCreate, useRoleUpdate } from '../../../entities/roles/hooks/role.hooks'
import { CreateRoleDto, UpdateRoleDto } from '../../../entities/roles/types/role.types'
import { PageHeader } from '../../shared/components/page-header'

export const RolesPage = () => {
  const { t } = useTranslation()
  const { data: apiPermissions } = useGetPermissions()
  const [isRoleModalOpen, setIsRoleModalOpen] = useState(false)
  const [choosedRole, setChoosedRole] = useState<Role | null>(null)
  const [columns, setColumns] = useState<any[]>([])
  const [name, setname] = useState<string | null>(null)
  const { mutateAsync: createRole } = useRoleCreate()
  const { mutateAsync: updateRole } = useRoleUpdate()
  const { data: roles } = useGetRoles()

  const handleRoleChoose = (role: Role) => {
    setChoosedRole(role)
    setIsRoleModalOpen(true)
  }

  useEffect(() => {
    setColumns(getRoleTableColumns(t, handleRoleChoose, handleDeleteRole, apiPermissions ?? []))
  }, [roles, apiPermissions])

  const showAddUserModal = (): void => {
    setIsRoleModalOpen(true)
    setname(null)
  }

  const handeSubmit = async (values: Omit<Role, 'id'>) => {
    const role: CreateRoleDto = {
      name: values.name,
      permissions: Object.keys(values.permissions).reduce((acc: number[], key) => {
        if (values.permissions[key]) {
          acc.push(Number(key))
        }

        return acc
      }, []),
    }
    if (choosedRole) {
      await updateRole({
        ...role,
        id: choosedRole.id,
      } as UpdateRoleDto)
    } else {
      await createRole(role)
    }
    setIsRoleModalOpen(false)
  }

  const handleAddUserCancel = () => {
    setIsRoleModalOpen(false)
    setChoosedRole(null)
  }

  const handleDeleteRole = (roleId: number) => {
    console.log(roleId)
  }

  return (
    <div className={clsx(styles.rolesPage)}>
      <PageHeader
        description={t('rolesPage.description')}
        header={t('rolesPage.header')}
      />
      <PureTable
        columns={columns}
        dataSource={roles}
        rowKey="id"
        searchPlaceholder={t('rolesPage.searchPlaceholder')}
        searchEnabled
      ></PureTable>
      <FloatButton
        icon={<PlusOutlined />}
        onClick={showAddUserModal}
        type="primary"
      />
      <RoleModal
        name={name}
        onCancel={handleAddUserCancel}
        onSubmit={handeSubmit}
        open={isRoleModalOpen}
        permissions={apiPermissions ?? []}
        role={choosedRole}
      />
    </div>
  )
}
